import React, { useEffect, useMemo, useState } from 'react';
import API from '../../services';
import Accordion from '../Accordion';
import './style.scss';


const FilterItem = ({ type, onChange, checked, name, id, value, label }) => {
    return (
        <div className="cbdce-education-finder-locate-form__input-group form-group form-inline">
            <input
                type={type}
                onChange={onChange}
                checked={checked === true}
                name={name}
                id={id}
                value={value}
            />
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

const FilterGroup = ({
    handleFilterChange,
    filterSelections,
    config: {
        type, options, name
    }
}) => options.map((option) => {
    const key = 'cbdce-education-finder--filter--' + name + '-' + option.value;
    const selected = filterSelections[name] && filterSelections[name].includes(option.value);

    return (
        <FilterItem
            key={key}
            type={type}
            onChange={handleFilterChange}
            checked={selected}
            name={name}
            id={key}
            value={option.value}
            label={option.label}
        />
    );
})

const proximityOptions = [
    { label: '5 miles', value: 5 },
    { label: '10 miles', value: 10 },
    { label: '25 miles', value: 25 },
    { label: '50 miles', value: 50 },
    { label: '75 miles', value: 75 },
    { label: '100 miles', value: 100 },
]

const Filters = ({
    handleFilterChange,
    handleClearAll,
    filterSelections,
    hasLocation,
    hasSearch,
    hasFilters
}) => {
    const [populationsServedFilters, setPopulationsServedFilters] = useState([]);
    const [focusAreasFilters, setFocusAreasFilters] = useState([]);
    const [languagesSpokenFilters, setLanguagesSpokenFilters] = useState([]);
    useEffect(() => {
        API.initSearchOptions().then((searchOptions) => {
            setFocusAreasFilters(searchOptions.focusAreas.map((option) => ({
                label: option.name, value: option.categoryId
            })));
            setPopulationsServedFilters(searchOptions.populationsServed.map((option) => ({
                label: option.name, value: option.categoryId
            })));
            setLanguagesSpokenFilters(searchOptions.languagesSpoken.map((option) => ({
                label: option.name, value: option.categoryId
            })));
        });
    }, []);

    const populationsServedConfig = useMemo(() => ({
        type: 'checkbox',
        options: populationsServedFilters,
        name: 'populationsServed',
    }), [populationsServedFilters]);

    const focusAreasConfig = useMemo(() => ({
        type: 'checkbox',
        options: focusAreasFilters,
        name: 'focusAreas',
    }), [focusAreasFilters]);

    const languageSpokenConfig = useMemo(() => ({
        type: 'checkbox',
        options: languagesSpokenFilters,
        name: 'languagesSpoken',
    }), [focusAreasFilters]);

    const proximityConfig = useMemo(() => ({
        type: 'radio',
        options: proximityOptions,
        name: 'proximity',
    }), [proximityOptions]);


    return (
        <div className="cbdce-education-finder__filters">
            <h4 className="cbdce-heading cbdce-heading--lg cbdce-heading--bm-16">Filters</h4>
            <p className="cbdce-education-finder__filters-desc">Select all that apply</p>
            <Accordion
                title="Populations Served"
                openOnMount={false}
            >
                <FilterGroup
                    config={populationsServedConfig}
                    handleFilterChange={handleFilterChange}
                    filterSelections={filterSelections}
                />
            </Accordion>
            <Accordion
                title="Focus Area"
                openOnMount={false}
            >
                <FilterGroup
                    config={focusAreasConfig}
                    handleFilterChange={handleFilterChange}
                    filterSelections={filterSelections}
                />
            </Accordion>
            <Accordion
                title="Languages Spoken"
                openOnMount={false}
            >
                <FilterGroup
                    config={languageSpokenConfig}
                    handleFilterChange={handleFilterChange}
                    filterSelections={filterSelections}
                />
            </Accordion>
            { hasLocation && (
                <Accordion
                    title="Proximity"
                    openOnMount={false}
                >
                    <FilterGroup
                        config={proximityConfig}
                        handleFilterChange={handleFilterChange}
                        filterSelections={filterSelections}
                    />
                </Accordion>
            )}
            {(hasFilters || hasSearch) && (
                <button
                    className="cbdce-button btn btn-block btn-secondary btn-outline"
                    style={{ marginTop: '40px' }}
                    onClick={handleClearAll}
                    type="button"
                >
                    <span className="cbdce-button__label">
                        Clear Filter(s)
                    </span>
                    <i className="fa-solid fa-xmark" />
                </button>
            )}
        </div>
    );
};

export default Filters;
